import getFactorClient from "./getFactorClient";

const getIsFrozen = state => {
  const client = getFactorClient(state);
  return Boolean(client && client.factored_receivables_frozen);
};

export default getIsFrozen;
